import useSWR from 'swr'

/**
 * A wallet's public activity through CADINU (Bez, 2026-10-07: the auto profile). Built by GET /api/social/history from sources the app
 * already keeps: the MultiSwap trade record, the shared CADINUdex trade feed, the competition API and the lock index. Nothing here is
 * private and nothing needs a signature; an address alone never creates a CADINU profile.
 */
export interface HistoryTrade {
  tx: string
  /** block time, unix seconds */
  t: number
  via: 'multiswap' | 'cadinudex'
  venue: string
  label: string
  usd: number | null
}
export interface HistoryCompetition {
  id: number
  /** the previous competition contract (V3): only its wins are known, not the board */
  legacy: boolean
  phase: string | null
  rank: number | null
  entrants: number | null
  winner: boolean
  prize: { token: string; amount: string } | null
  claimed: boolean | null
}
export interface HistoryLock {
  type: 'v2' | 'v3'
  id: number
  title: string
  phase: 'locked' | 'vesting' | 'due' | 'released'
  unlockAt: number
  valueUsd: number | null
}
export interface WalletHistory {
  wallet: string
  builtAt: number
  /** no trade, competition or lock was found (every source answered) */
  empty: boolean
  trades: { ok: boolean; count: number; volumeUsd: number | null; items: HistoryTrade[] }
  competitions: { ok: boolean; joined: number; won: number; items: HistoryCompetition[] }
  locks: { ok: boolean; count: number; valueUsd: number | null; items: HistoryLock[] }
}

const ADDRESS = /^0x[0-9a-fA-F]{40}$/
const fetchJson = async (url: string) => {
  const r = await fetch(url)
  if (!r.ok) throw new Error(`http_${r.status}`)
  return r.json()
}

export function useWalletHistory(wallet?: string | null) {
  const ok = Boolean(wallet && ADDRESS.test(wallet))
  return useSWR<WalletHistory>(ok ? `/api/social/history?wallet=${wallet}` : null, fetchJson, { revalidateOnFocus: false, shouldRetryOnError: false, dedupingInterval: 30_000 })
}
